import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapArtwork: {
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      '& $wrapInfo': {
        opacity: 1,
      },
      '& $wrapdots': {
        opacity: 0.5,
        visibility: 'visible',
      },
    },
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  line: {
    '&::after': {
      content: '","',
      display: 'inline-block',
    },
    '&:last-child': {
      '&::after': {
        content: '""',
        display: 'none',
      },
    },
  },
  image: {
    height: 360,
  },
  imageLoading: {
    '&.MuiSkeleton-root': {
      borderRadius: 8,
    },
  },
  spacingTop: {
    marginTop: 6,
  },

  // ArtworkItemInfo
  wrapInfo: {
    width: '100%',
    padding: 16,
    paddingTop: 4,
    position: 'absolute',
    left: 0,
    bottom: 0,
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.70)  12.27%, rgba(0, 0, 0, 0.00) 98%)',
    opacity: 0,
    transition: 'all 0.5s',
    zIndex: 0,
  },

  // ArtworkItemPopover
  wrapdots: {
    width: 22,
    height: 22,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 16,
    right: 16,
    borderRadius: 2,
    background: Colors.Grey10,
    opacity: 0,
  },
  dotActive: {
    opacity: '0.5 !important',
  },
  iconDots: {
    '&.MuiSvgIcon-root': {
      width: 12,
      height: 12,
      color: Colors.White,
      zIndex: 999,
    },
  },
  wrapPopoverContent: {
    padding: 8,
    background: Colors.White,
    cursor: 'pointer',
  },
  popover: {
    '& .MuiPopover-paper': {
      marginTop: 8,
      padding: 8,
    },
  },

  buttonDialog: {
    '&.MuiButton-root': {
      minWidth: 90,
      padding: '10px 16px',
      fontSize: '1.6rem',
      fontWeight: 400,
      lineHeight: '150%',
      letterSpacing: 0.64,
    },
  },
  buttonDanger: {
    '&.MuiButton-root': {
      marginLeft: 16,
      background: Colors.Error,
      '&:hover': {
        background: Colors.Error,
      },
    },
  },

  disable: {
    pointerEvents: 'none',
    opacity: 0.5,
    cursor: 'not-allowed',
  },

  exportWrapper: {
    position: 'fixed',
    left: -10000,
    top: 0,
    overflow: 'visible',
    pointerEvents: 'none',
    opacity: 0,
    zIndex: -1,
  },
  certificateExportPage: {
    maxWidth: 899,
    minWidth: 899,
    minHeight: 1150,
    maxHeight: 1150,
    padding: 64,
    paddingBottom: 59,
    background: Colors.White,
    position: 'relative',
  },
  certificateCornerTopLeft: {
    position: 'absolute',
    top: 201,
    left: 84,
    zIndex: -10,
  },
  certificateCornerTopRight: {
    position: 'absolute',
    top: 207,
    right: 98,
    zIndex: -10,
  },
  certificateCornerBottomRight: {
    position: 'absolute',
    bottom: 262,
    right: 96,
    zIndex: -10,
  },
  certificateCornerBottomLeft: {
    position: 'absolute',
    bottom: 264,
    left: 99,
    zIndex: -10,
  },
  certificateLine: {
    width: '100%',
    height: 49,
    background: '#F5F5F5',
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translateY(-50%)',
    zIndex: -10,
  },
  certificateTextCertificatePage1: {
    color: '#404040',
    fontFamily: 'Readex Pro',
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: 200,
    lineHeight: '12px',
    letterSpacing: 0.4,
    position: 'absolute',
    top: '50%',
    right: 16,
    zIndex: -9,
    transform: 'translateY(-117px) rotate(270deg)',
    transformOrigin: 'right center',
  },
}));

export default useStyles;
